import whitespace from './validators/whitespace'
import variables from './validators/variables'
import combineValidators from './validators/combineValidators'

const validators = [whitespace, variables]
export default combineValidators(validators)
